module.exports = __webpack_public_path__ + "assets/img/undo.1caa9b49.svg";